isTrello = require './is-trello'
parseURL = require 'url-parse'

module.exports = (url) ->
  if !isTrello(url)
    return { type: 'unknown' }

  parsed = parseURL(url)
  [identifier, shortLink] = parsed.pathname.split('/')[1..]

  type =
    switch identifier
      when 'b' then 'board'
      when 'c' then 'card'
      when 'e' then 'enterprise'
      else 'unknown'

  shortLink =
    if type in ['card', 'board']
      shortLink
    else
      undefined

  {
    type
    shortLink
  }



// WEBPACK FOOTER //
// ./app/scripts/lib/util/url/parse-trello-url.coffee